import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { V2Position } from '@flipster/socket/r230522/position';
import Num from '@flipster/utils/num';

import { DefaultLeverageMarginModeButton } from '@web/app/[locale]/(web)/trade/_misc/order-form/perpetual/modals/default-leverage-margin-mode-button';

import { adjustLeverageModalBunja } from '../state';
import { LeverageControls } from './leverage-controls';
import { OneWayNotice } from './one-way-notice';
import { PositionHeader } from './position-header';

export interface AdjustLeverageModalBodyProps {
  position?: V2Position | null;
  symbol: string;
  pricePrecision: number;
  modeMaxLeverage: number;
  from: 'orderform' | 'open-positions';
  onOpenDefaultLeverageMarginMode?: () => void;
}

export const AdjustLeverageModalBody = ({
  position,
  symbol,
  pricePrecision,
  modeMaxLeverage,
  from,
  onOpenDefaultLeverageMarginMode,
}: AdjustLeverageModalBodyProps) => {
  const { tradeModeAtom, hasAnyPositionAtom } = useBunja(adjustLeverageModalBunja);
  const hasAnyPosition = useAtomValue(hasAnyPositionAtom);
  const tradeMode = useAtomValue(tradeModeAtom);
  const isOneWay = tradeMode === 'OneWay';

  return (
    <>
      {from === 'orderform' && isOneWay && hasAnyPosition && <OneWayNotice />}
      {from === 'open-positions' && position && Num(position.position).abs().isGreaterThan(0) && (
        <PositionHeader position={position} pricePrecision={pricePrecision} />
      )}
      <LeverageControls symbol={symbol} modeMaxLeverage={modeMaxLeverage} />
      {from === 'orderform' && onOpenDefaultLeverageMarginMode && (
        <DefaultLeverageMarginModeButton onClick={onOpenDefaultLeverageMarginMode} />
      )}
    </>
  );
};
